import { captureException } from "@sentry/react";

// -----------------------------------------------------------------------------

export function captureSentryException(
  error: unknown,
  transactionName: string
) {
  captureException(error, (scope) => {
    scope.setTransactionName(transactionName);

    //
    return scope;
  });
}
